import * as React from 'react'
import {useSearchParams} from 'react-router-dom'
import {useLaunchControlReturn} from './components/use-launch-control-return'
import {ChromeContext, type ChromeContextValue} from './use-chrome-context'

export function ChromeProvider({children}: {children: React.ReactNode}): React.ReactElement {
  const [params] = useSearchParams()
  const chromeParam = params.get('chrome')
  const enabled = chromeParam !== null && chromeParam !== 'freckle'
  const {resource: launchControlReturn} = useLaunchControlReturn({enabled})

  const value: ChromeContextValue = React.useMemo(
    () => ({
      launchControlReturn,
      chromeParam,
      enabled
    }),
    [launchControlReturn, chromeParam, enabled]
  )

  return <ChromeContext.Provider value={value}>{children}</ChromeContext.Provider>
}
